import { render, staticRenderFns } from "./ImportantInformation.vue?vue&type=template&id=a02d544e&scoped=true&lazy=true"
import script from "./ImportantInformation.vue?vue&type=script&lang=js"
export * from "./ImportantInformation.vue?vue&type=script&lang=js"
import style0 from "./ImportantInformation.vue?vue&type=style&index=0&id=a02d544e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02d544e",
  null
  
)

export default component.exports